import { Component, Input } from '@angular/core';

// todo(feat): currently supports only light mode, also support dark mode
@Component({
  selector: 'emperor-penguin-power',
  templateUrl: './penguin-power.component.svg',
  styleUrls: ['./penguin-power.component.scss'],
})
export class PenguinPowerComponent {
  @Input() width = 251.7;
  @Input() height = 97.1;
}
